// Generated by scripts/sync-catalog-sitemap.mjs — do not edit by hand.
// Re-run: pnpm sync:catalog-sitemap
export const providersSlugMap = {
    "1x2gaming": "1X2gaming",
    "3oaks": "3oaks",
    "avatarux": "AvatarUX",
    "bgaming": "BGaming",
    "blueprint-gaming": "Blueprint Gaming",
    "boominggames": "BoomingGames",
    "fantasma": "Fantasma",
    "fbastards": "Fbastards",
    "gametech": "GameTech",
    "gamomat-games": "Gamomat Games",
    "habanero": "Habanero",
    "hacksaw-gaming": "Hacksaw Gaming",
    "indigomagic": "IndigoMagic",
    "irondog": "IronDog",
    "jili-games": "Jili Games",
    "manna-play": "Manna Play",
    "million-games": "Million Games",
    "netent": "NetEnt",
    "peter-and-sons": "Peter & Sons",
    "pgsoft": "PGSoft",
    "pinoy-bet-games": "Pinoy Bet Games",
    "play-n-go": "Play n GO",
    "playzia": "Playzia",
    "pragmatic-play": "Pragmatic Play",
    "pragmatic-play-live": "Pragmatic Play Live",
    "push-gaming": "Push Gaming",
    "quickspin": "Quickspin",
    "relax-gaming": "Relax Gaming",
    "tomhorn": "TomHorn",
    "wazdan": "Wazdan",
    "winfast": "Winfast",
};
